'use client';
import Cookies from "js-cookie";
import {CookieName, CookieValue} from "@web-libs/features/auth/main/domain/auth.constants";

const useAuthCookies = ():AuthStorageConcern => {

    const saveToken = (token:string) => {
        Cookies.set(CookieName, CookieValue);
    }

    const removeToken = () => {
        Cookies.remove(CookieName);
    }

    return {
        saveAuthToken:saveToken,
        removeAuthToken:removeToken,
    };
};

export default useAuthCookies;

export interface AuthStorageConcern {
    saveAuthToken: (value: string) => void;
    removeAuthToken: () => void;
}
